import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from '../services/api.service';
import { PayrollItemEditDialogComponent } from '../payroll-item-edit-dialog/payroll-item-edit-dialog.component';

@Component({
  selector: 'app-payroll-run-details',
  templateUrl: './payroll-run-details.component.html',
  styleUrls: ['./payroll-run-details.component.scss']
})
export class PayrollRunDetailsComponent implements OnInit {

  runId: number;
  run: any;
  itemsDataSource = new MatTableDataSource<any>([]);
  displayedColumns = ['employeeId','baseSalary','totalAllowances','totalDeductions','netPay','actions'];
  isLoading = false;

  constructor(
    private route: ActivatedRoute,
    private apiService: ApiService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.runId = Number(this.route.snapshot.paramMap.get('runId'));
    this.loadRun();
    this.loadItems();
  }

  loadRun(): void {
    this.apiService.getPayrollRuns().subscribe(

      data => {

        const runs = (data && data.runs) ? data.runs : [];

        this.run = runs.find((r: any) => r.runId === this.runId);

        if (!this.run) {

          this.snackBar.open('Payroll run not found for this ID.', 'Close', { duration: 3000 });

        }

      },

      _ => {

        this.snackBar.open('Failed to load payroll run details.', 'Close', { duration: 3000 });

      }

    );
  }

  loadItems(): void {
    this.isLoading = true;
    this.apiService.getPayrollRunItems(this.runId).subscribe(
      data => {
        this.itemsDataSource = new MatTableDataSource<any>(data || []);
        this.isLoading = false;
      },
      _ => {
        this.isLoading = false;
        this.snackBar.open('Failed to load payroll items', 'Close', { duration: 3000 });
      }
    );
  }

  submit(): void {
    this.apiService.submitPayrollRun(this.runId).subscribe(_ => {
      this.snackBar.open('Run submitted for review', 'Close', { duration: 3000 });
      this.loadRun();
    });
  }

  approve(): void {
    this.apiService.approvePayrollRun(this.runId).subscribe(_ => {
      this.snackBar.open('Run approved', 'Close', { duration: 3000 });
      this.loadRun();
    });
  }

  post(): void {
    this.isLoading = true;
    this.apiService.postPayrollRun(this.runId).subscribe(
      _ => {
        this.isLoading = false;
        this.snackBar.open('Run posted to wages', 'Close', { duration: 3000 });
        this.loadRun();
      },
      err => {
        this.isLoading = false;
        const msg = err?.error?.message || 'Failed to post run';
        this.snackBar.open(msg, 'Close', { duration: 4000 });
      }
    );
  }

  resetRun(): void {

    const confirmReset = confirm(

      'This will delete this payroll run and all wages for this month so you can start over. Are you sure?'

    );

    if (!confirmReset) {

      return;

    }

    this.isLoading = true;

    this.apiService.resetPayrollRun(this.runId).subscribe(

      _ => {

        this.isLoading = false;

        this.snackBar.open('Run and wages reset for this month', 'Close', { duration: 3000 });

        this.loadRun();

      },

      err => {

        this.isLoading = false;

        const msg = err?.error?.message || 'Failed to reset run';

        this.snackBar.open(msg, 'Close', { duration: 4000 });

      }

    );

  }

  editItem(row: any): void {
    const dialogRef = this.dialog.open(PayrollItemEditDialogComponent, {
      width: '500px',
      data: { item: row }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.apiService.updatePayrollItem(result).subscribe(
          _ => {
            this.snackBar.open('Payroll item updated', 'Close', { duration: 3000 });
            this.loadItems();
          },
          _ => {
            this.snackBar.open('Failed to update item', 'Close', { duration: 3000 });
          }
        );
      }
    });
  }
}
